import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { Orgao } from "../../orgaos/shared/orgao.model";
import { areasModuleName, areasStorage } from "../shared/data.service";
import { estruturasModuleName } from "../../shared/data.service";
import { PhoneValidator } from "../../../shared/validators/phone.validation";
import { UtilService } from "../../../shared/services/util.service";
import { editRoute, newRouteFemale } from "../../../shared/services/data.service";
import { Area } from "../shared/area.model";
import { AreaApiService } from "../shared/area-api.service";
import { AreaService } from "../shared/area.service";
import { AreaNavigationService } from "../shared/area-navigation.service";
import { orgaosStorage, orgaosQuery } from "../../orgaos/shared/data.service";
import { OrgaoNavigationService } from "../../orgaos/shared/orgao-navigation.service";
import { OrgaoApiService } from "../../orgaos/shared/orgao-api.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { EmailValidator } from "../../../shared/validators/email.validation";
import { AreaContato } from "../area-contatos/area-contato.model";
import { ContatoTipoService } from "../../../recursos-humanos/contatos/contato-tipos/shared/contato.service";
import { AreaContatoApiService } from "../area-contatos/area-contato-api.service";

@Component({
    template: require('./area-form.component.html'),
    styles: [require('./area-form.component.css')]
})
export class AreaFormComponent implements OnInit {
    estruturasModule: any = estruturasModuleName;
    areasModule: any = areasModuleName;
    formObject: any = new Area();
    orgaoObject: any = new Orgao();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    showSelectOrgao: boolean = false;

    orgaoSelectId: string = 'orgaoSelect';
    orgaoQuery: any = orgaosQuery;
    contatosList: any[] = [];

    form: FormGroup;
    ativo = new FormControl('');
    nome = new FormControl('', Validators.required);
    codigoUnidadeOrcamentaria = new FormControl('');
    nomeResponsavel = new FormControl('');
    telefoneResponsavel = new FormControl('', Validators.compose([PhoneValidator.phoneFormat]));
    emailResponsavel = new FormControl('', Validators.compose([EmailValidator.emailFormat]));
    orgao = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responsArea: any;

    constructor(
        private _route: ActivatedRoute,
        private _utilService: UtilService,
        private _areaApiService: AreaApiService,
        private _areaService: AreaService,
        private _areaNavigationService: AreaNavigationService,
        private _orgaosNavigationService: OrgaoNavigationService,
        private _orgaoApiService: OrgaoApiService,
        private _autocompleteService: AutoCompleteService,
        private _contatoTipoService: ContatoTipoService,
        private _areaContatoApiService: AreaContatoApiService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            nome: this.nome,
            codigoUnidadeOrcamentaria: this.codigoUnidadeOrcamentaria,
            nomeResponsavel: this.nomeResponsavel,
            telefoneResponsavel: this.telefoneResponsavel,
            emailResponsavel: this.emailResponsavel,
            orgao: this.orgao
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.orgaoObject.id) {
                object.orgaoId = this.orgaoObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (object.telefoneResponsavel) {
                object.telefoneResponsavel = this._utilService.removeSpecialCharacter(object.telefoneResponsavel);
            }

            if (this.contatosList.length) {
                var contatos:Array<AreaContato> = [],
                    cloneContatos: any[] = this._utilService.cloneObject(this.contatosList),
                    x: any, lenX: any;

                for (x = 0, lenX = cloneContatos.length; x < lenX; x++) {
                    if (cloneContatos[x].contato && cloneContatos[x].tipo) {
                        cloneContatos[x].tipoContatoId = cloneContatos[x].tipo.id;

                        delete cloneContatos[x]['tipo'];

                        contatos.push(cloneContatos[x]);
                    }
                }
                object.Contatos = contatos;
            }

            if (this.formObject.id) {
                this.onEditArea(object);
            } else {
                this.onAddArea(object);
            }
        }
    }

    getOrgaosObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.formObject;
            thisFormObject.orgao = this.orgaoObject;
            thisFormObject.Contatos = this.contatosList;

            this._areaService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                razaoSocial: object.text,
                form: areasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, orgaosStorage);
            this._orgaosNavigationService.goToNew();
        } else {
            this.orgaoObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'orgao', object);
        }
    }

    private onAddArea(object: Area) {
        this._areaApiService.onPost(object, this.onDone);
    }

    private onEditArea(object: Area) {
        this._areaApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responsArea = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma área encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._areaApiService.onGetById(id, onDone);
    }

    private getContatosAreas(areaId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.contatosList = Response;
            }
        }.bind(this));

        this._areaContatoApiService.onGetByArea(areaId, onDone);
    }

    private setModelToForm() {
        if (this.formObject.orgao) {
            this.orgaoObject = this.formObject.orgao;
            delete this.formObject['orgao'];

            var selectObject:any = {text: this.orgaoObject.razaoSocial, id: this.orgaoObject.id};

            this._autocompleteService.createOptionOnSelect2(this.orgaoSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.orgaoSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'orgao', this.orgaoObject);
        }

        if (this.formObject.Contatos) {
            this.contatosList = this.formObject.Contatos;
            delete this.formObject['Contatos'];
        }
    }

    private goToList() {
        this._areaService.clearSessionStorage();
        this._areaNavigationService.goToList();
    }

    private testSession() {
        var id: number;
        var session: any = this._areaService.getSessionStorage();
        this._areaService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            if (id) {
                this.setEditSession();
            } else {
                this.setNewSession();
            }
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.showSelectOrgao = true;
        this.getContatosAreas(id);
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
        this.orgaoObject = this._areaService.getSessionStorageFatherModule();
        this.setModelToForm();
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
        this.showSelectOrgao = true;
        setTimeout(function () {
            this.setModelToForm();
        }.bind(this));
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
        this.setModelToForm();
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(areasStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.nome = newAutoComplete.nome;
            this.showSelectOrgao = true;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._areaService.returnToOtherForm(this.otherForm, this.responsArea);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/area-form/area-form.component.ts
 **/